module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-11 col-sm-4 alert open",
    class: [_vm.verticalAlign, _vm.horizontalAlign, _vm.alertType],
    style: (_vm.customPosition),
    attrs: {
      "data-notify": "container",
      "role": "alert",
      "data-notify-position": "top-center"
    }
  }, [_c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "5px",
      "z-index": "1033"
    },
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "data-notify": "dismiss"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-xs-1 alert-icon",
    class: _vm.icon
  }), _vm._v(" "), _c('div', {
    class: _vm.hasIcon ? 'col-xs-8' : 'col-xs-12'
  }, [_vm._t("message", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e34c802!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/NotificationPlugin/Notification.vue
// module id = 354
// module chunks = 1